import type { VoidFunctionComponent } from 'react';

import Tabs, { useTabs } from '../../generic/Tabs';

import SearchDependency from './SearchDependency';

import styles from './index.module.less';

export type AddDependencyDrawerProps = {
  userRevisionLocator: string;
  isVendored?: boolean;
};

const tabIds = ['Search', 'Upload', 'Create'] as const;
type TabId = typeof tabIds[number];

/**
 * Drawer component for adding a dependency (manual or vendored). Manual dependencies
 * can be added via one of three workflows: Search, Upload, or Create.
 */
const AddDependencyDrawer: VoidFunctionComponent<AddDependencyDrawerProps> = ({
  userRevisionLocator,
  isVendored,
}) => {
  const { tabs, activeTab } = useTabs<TabId>({ tabIds });
  return (
    <div>
      <h2 className={styles.header}>Add {isVendored ? 'vendored' : 'manual'} dependency</h2>
      <div>(Placeholder) User Revision Locator: {userRevisionLocator}</div>
      <Tabs>
        {tabs.map(tab => (
          <Tabs.Tab
            key={tab.label}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...tab}
          />
        ))}
      </Tabs>
      <div className={styles.content}>
        {activeTab === 'Search' && <SearchDependency isVendored={isVendored} />}
        {activeTab === 'Upload' && <div>(Placeholder) Upload Workflow</div>}
        {activeTab === 'Create' && <div>(Placeholder) Create Workflow</div>}
      </div>
    </div>
  );
};

export default AddDependencyDrawer;
